import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_1432626986 from "../../../../../packages/component/src/components/rating/demo/demo1.js?loadDemo";
import legacyImportDemo_3888478281 from "../../../../../packages/component/src/components/rating/demo/demo2.js?loadDemo";
import legacyImportDemo_900481128 from "../../../../../packages/component/src/components/rating/demo/demo3.js?loadDemo";
import legacyImportDemo_4186432143 from "../../../../../packages/component/src/components/rating/demo/demo4.js?loadDemo";
import legacyImportDemo_868687022 from "../../../../../packages/component/src/components/rating/demo/demo5.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_1432626986,
  legacyImportDemo_3888478281,
  legacyImportDemo_900481128,
  legacyImportDemo_4186432143,
  legacyImportDemo_868687022,
  React
};